import { render, staticRenderFns } from "./PermissionPopup.vue?vue&type=template&id=57cba314"
import script from "./PermissionPopup.vue?vue&type=script&lang=js"
export * from "./PermissionPopup.vue?vue&type=script&lang=js"
import style0 from "./PermissionPopup.vue?vue&type=style&index=0&id=57cba314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports